import {
	API_GET_ALL_ANALYSISLIBRARY,
	API_GET_ALL_ANALYSISLIBRARY_SUCCESS,
	API_GET_ALL_ANALYSISLIBRARY_FAIL,
	API_GET_ANALYSES_COST,
	API_GET_ANALYSES_COST_SUCCESS,
	API_GET_ANALYSES_COST_FAIL,
	API_GET_MATCHING_ANALYSES,
	API_GET_MATCHING_ANALYSES_SUCCESS,
	API_GET_MATCHING_ANALYSES_FAIL,
	RESET_COSTS,
} from "actions/analysisLibrary";
import { API_GET_ALL_ANALYSESPACK_SUCCESS, API_GET_ANALYSESPACKS_DEPOSITS_SUCCESS } from "actions/analysesPack";
import { errorHandler, ErrorAction } from "utils/error";
import { toast } from "react-toastify";
import { getVersion } from "services/analysisLibrary";
import { V2_CLIENT } from "config/clientConstants";

const initialState = {
	list: [],
	packs: [],
	loading: false,
	matchingIdList: [],
	resultMatching: null,
	cost: [],
	motivations: [],
	loadingCosts: false,
	depositsPacks: [],
};

const adaptAnalysesCostItemResponse = (item, currentClient) => {
	try {
		if (!item || currentClient !== V2_CLIENT) {
			return item;
		}

		const adapted = { ...item };

		const fieldMap = {
			toMotivate: "to_motivate",
			analysisId: "analysis_id",
		};

		Object.keys(fieldMap).forEach((camelKey) => {
			if (adapted[camelKey] !== undefined && adapted[fieldMap[camelKey]] === undefined) {
				adapted[fieldMap[camelKey]] = adapted[camelKey];
			}
		});

		return adapted;
	} catch (error) {
		console.error("Error in adaptAnalysesCostItemResponse:", error);
		return item;
	}
};

const adaptAnalysesCostResponse = (cost, currentClient) => {
	try {
		if (!cost || currentClient !== V2_CLIENT) {
			return cost;
		}

		const adapted = { ...cost };

		if (Array.isArray(adapted.items)) {
			adapted.items = adapted.items.map((item) => adaptAnalysesCostItemResponse(item, currentClient));
		}

		return adapted;
	} catch (error) {
		console.error("Error in adaptAnalysesCostResponse:", error);
		return cost;
	}
};

const adaptAnalysesCostPayloadResponse = (action, actionType) => {
	try {
		const payload = action.payload || {};
		const data = payload.data;
		const currentClient = action.meta?.previousAction?.payload?.client || getVersion(actionType).currentClient;

		if (!data) {
			return payload;
		}

		if (currentClient === V2_CLIENT) {
			if (Array.isArray(data)) {
				return {
					...payload,
					data: data.map((cost) => adaptAnalysesCostResponse(cost, currentClient)),
				};
			}
		}

		return payload;
	} catch (error) {
		console.error("Error in adaptAnalysesCostPayloadResponse:", error);
		return action.payload || {};
	}
};

export default function analysisLibrary(state = initialState, action) {
	switch (action.type) {
		case API_GET_ALL_ANALYSISLIBRARY:
			return {
				...state,
				loading: true,
				error: null,
			};

		case API_GET_ALL_ANALYSISLIBRARY_SUCCESS:
			return {
				...state,
				loading: false,
				list: action.payload.data.library,
				error: null,
			};
		case API_GET_ALL_ANALYSISLIBRARY_FAIL:
			errorHandler("Catalogue d'analyses", ErrorAction.READ, action.error);
			return {
				...state,
				loading: false,
				list: [],
				error: "Error getting analyses library",
			};

		case API_GET_ALL_ANALYSESPACK_SUCCESS:
			return {
				...state,
				packs: action.payload.data,
			};

		case API_GET_ANALYSES_COST:
			return {
				...state,
				loading: true,
				error: null,
				costs: [],
				motivations: [],
				loadingCosts: true,
				isOpen: action.payload.request.data && action.payload.request.data.length > 0 ? action.payload.request.data[0].isOpen : false,
			};

		case API_GET_ANALYSES_COST_SUCCESS:
			const adaptedCostPayload = adaptAnalysesCostPayloadResponse(action, API_GET_ANALYSES_COST);
			if (action.payload.data.length === 0 && state?.isOpen) toast.error("Une erreur s'est produite lors du calcul du coût.");
			return {
				...state,
				loading: false,
				costs: adaptedCostPayload.data || [],
				motivations: (adaptedCostPayload.data || []).flatMap((elt) => {
					return elt.items
						? elt.items
								.filter((i) => i.to_motivate)
								.map((i) => {
									return { id: i.analysis_id, title: i.title, motivations: i.to_motivate };
								})
						: [];
				}),
				loadingCosts: false,
			};
		case API_GET_ANALYSES_COST_FAIL:
			return {
				...state,
				loading: false,
				costs: [],
				error: "Erreur de récupération des coûts",
				motivations: [],
				loadingCosts: false,
			};

		case API_GET_MATCHING_ANALYSES:
			return {
				...state,
				loading: true,
				error: null,
				matchingIdList: [],
				resultMatching: null,
			};

		case API_GET_MATCHING_ANALYSES_SUCCESS:
			return {
				...state,
				loading: false,
				matchingIdList: action.payload.data.anal,
				resultMatching: action.payload.data.result,
			};
		case API_GET_MATCHING_ANALYSES_FAIL:
			return {
				...state,
				loading: false,
				matchingIdList: [],
				resultMatching: null,
				error: "Error getting analyses cost",
			};
		case RESET_COSTS:
			return {
				...state,
				costs: [],
			};

		case API_GET_ANALYSESPACKS_DEPOSITS_SUCCESS:
			return {
				...state,
				depositsPacks: action.payload.data,
			};
		default:
			return state;
	}
}
